import * as React from "react";
import Toast from "../components/toast";
import { LanguageContext } from "../context/language-context";

// Custom hook to use the LanguageContext
export const useLanguage = () => {
  return React.useContext(LanguageContext);
};
